import { useFormContext } from 'react-hook-form'

import useElemId from './useElemId'
import useInputOnAutoSubmit from './useInputOnAutoSubmit'
import useInputUnavailable from './useInputUnavailable'
import useIsDisabled from './useIsDisabled'
import { InputTextProps } from '../interfaces'

export default function useInputText(props: InputTextProps): any {
  const ctx = useFormContext()
  const elemId = useElemId(props)
  const isUnavailable = useInputUnavailable(props)
  const isDisabled = useIsDisabled(props, isUnavailable)
  const { canAutoSubmit, onSubmit } = useInputOnAutoSubmit(props)
  return { ctx, elemId, isDisabled, canAutoSubmit, onSubmit }
}
